<div>
  <qrcode *ngIf="qrdata" [qrdata]="qrdata" [ariaLabel]="'QR Code image with the event url'" [cssClass]="'center'"
    [colorDark]="'#2e2e2e'" [colorLight]="'#ffffffff'" [elementType]="'canvas'" [errorCorrectionLevel]="'M'"
    [imageSrc]="'https://iti-images.s3.amazonaws.com/imgs/iti-s.png'" [imageHeight]="20" [imageWidth]="20" [margin]="0"
    [scale]="1" [title]="'Scan to view on your mobile phone'" [width]="75"></qrcode>
</div>